// extracted by mini-css-extract-plugin
module.exports = {"Container":"Settings_Container__1X1Ye","Menu":"Settings_Menu__2Kg0C","Active":"Settings_Active__Pd2_N","Content":"Settings_Content__2vnrr"};